import React, { useEffect, useState } from "react";
import { Modal, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";

export interface DropDownFieldProps {
    options: Array<string | { id: string; title: string }>;
    label?: string;
    onSubmit:(selectedItems:any)=>void;
    isObjectList?: boolean;
    isCloseOnSelection?: boolean;
    onChangeText?: (selectedValues: Array<string | { id: string; title: string }>) => void;
}

export default function MultiSelect({ isObjectList = false, isCloseOnSelection = false, options, label, onChangeText ,onSubmit}: DropDownFieldProps) {
    const [visible, setVisible] = useState(false);
    const [selectedItems, setSelectedItems] = useState<Array<string | { id: string; title: string }>>([]);
    const [displayValue, setDisplayValue] = useState('');

    useEffect(() => {
        const values = selectedItems.map(item => isObjectList ? item.title : item);
        setDisplayValue(values.join(', '));
        if (onChangeText) onChangeText(selectedItems);
    }, [selectedItems]);

    const toggleItemSelection = (item: string | { id: string; title: string }) => {
        const index = selectedItems.findIndex(selectedItem => selectedItem.id === (item as { id: string }).id);
        if (index === -1) {
            setSelectedItems([...selectedItems, item]);
        } else {
            const updatedItems = [...selectedItems];
            updatedItems.splice(index, 1);
            setSelectedItems(updatedItems);
        }
    };

    return (
        <View style={{ width: '100%' }}>
            <TouchableOpacity onPress={() => setVisible(true)}>
                <Text>{label}</Text>
                <Text>{displayValue}</Text>
            </TouchableOpacity>
            {/* <button onClick={()=>onSubmit(selectedItems)}>Save</button> */}
            <PickerModal
                options={options}
                visible={visible}
                onClose={() => setVisible(false)}
                selectedItems={selectedItems}
                toggleItemSelection={toggleItemSelection}
                isObjectList={isObjectList}
                isCloseOnSelection={isCloseOnSelection}
            />
        </View>
    );
}

function PickerModal({ visible, onClose, options, selectedItems, toggleItemSelection, isObjectList, isCloseOnSelection }: any) {
    return (
        <Modal
            animationType="fade"
            transparent={true}
            visible={visible}
            onRequestClose={onClose}
        >
            <View style={{ flex: 1, justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0,0,0,0.5)" }}>
                <View style={{ backgroundColor: "white", width: 343, maxHeight: '60%', borderRadius: 25, overflow: "hidden" }}>
                    <ScrollView showsVerticalScrollIndicator={false}>
                        {options.map(option => (
                            <TouchableOpacity
                                key={isObjectList ? option.id : option}
                                onPress={() => toggleItemSelection(option)}
                            >
                                <Text style={{
                                    fontFamily: "Outfit",
                                    fontSize: 18,
                                    paddingLeft: 20,
                                    backgroundColor: selectedItems.some(item => item.id === (option as { id: string }).id) ? 'rgba(0,0,0,0.1)' : undefined,
                                    paddingVertical: 20,
                                    color: 'black'
                                }}>
                                    {isObjectList ? (option as { title: string }).title : option}
                                </Text>
                            </TouchableOpacity>
                        ))}
                    </ScrollView>

                    <View style={{ flexDirection: "row", justifyContent: "space-evenly" }}>
                        <TouchableOpacity onPress={onClose} style={{ fontFamily: "Outfit", fontSize: 18, flex: 1, textAlign: "center", backgroundColor: 'rgba(0,0,0,0.05)', paddingVertical: 20 }}>
                            <Text>Cancel</Text>
                        </TouchableOpacity>
                        <TouchableOpacity onPress={() => {
                            onClose();
                            if (isCloseOnSelection) onClose(selectedItems);
                        }} style={{ fontFamily: "Outfit", fontSize: 18, flex: 1, textAlign: "center", paddingVertical: 20 }}>
                            <Text>Done</Text>
                        </TouchableOpacity>
                    </View>
                </View>
            </View>
        </Modal>
    );
}
